import React from "react";
const urlApi = process.env.REACT_APP_STRAPI_URL;
export default function VideoComex({
  video,
  poster,
  controls,
  autoPlay,
  muted,
  loop,
}) {
  const posterUrl = poster ? `${urlApi}${poster}` : undefined;
  const videoUrl = video ? `${urlApi}${video}` : undefined;

  return (
    <section className="w-full flex flex-col items-center justify-center">
      <div className="w-full aspect-video max-h-[780px]">
        <video
          controls={controls}
          autoPlay={autoPlay}
          muted={muted}
          loop={loop}
          playsInline
          poster={posterUrl}
          className="w-full h-full object-cover aspect-video "
        >
          <source src={videoUrl} type="video/webm" />
        </video>
      </div>
    </section>
  );
}
